import '../../Scss/components/_tabs.scss';
import { addClass, getElement, getElements, removeClass } from '../helpers/functions';
class Tabs {
  constructor(element) {
    // Main container element
    this.tabContainer = element;

    // Tab elements
    this.tabs = getElements('[role="tab"]', this.tabContainer);
    this.tabPanels = getElements('[role="tabpanel"]', this.tabContainer);

    // State
    this.activeTab = this.tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || this.tabs[0];

    // Bind methods
    this.handleClick = this.handleClick.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);

    // Initialize
    this.init();
  }
  init() {
    this.tabs.forEach(tab => {
      // Add event listeners
      tab.addEventListener('click', this.handleClick);
      tab.addEventListener('keydown', this.handleKeydown);
    });

    // Set initial active tab if none is already active
    if (this.activeTab) {
      this.activateTab(this.activeTab);
    }
  }
  activateTab(tab) {
    // Deactivate all tabs
    this.tabs.forEach(t => {
      t.setAttribute('aria-selected', 'false');
      removeClass(t, '__active');
    });

    // Hide all panels
    this.tabPanels.forEach(panel => {
      removeClass(panel, '__open');
    });

    // Activate selected tab
    addClass(tab, '__active');
    tab.setAttribute('aria-selected', 'true');

    // Show selected panel
    const panelId = tab.getAttribute('aria-controls');
    const panel = getElement(`#${panelId}`, this.tabContainer);
    if (panel) {
      addClass(panel, '__open');
    }
    this.activeTab = tab;
  }
  handleClick(event) {
    event.preventDefault();
    const tab = event.currentTarget;
    this.activateTab(tab);
  }
  handleKeydown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    let targetTab;
    const firstTab = this.tabs[0];
    const lastTab = this.tabs[this.tabs.length - 1];
    switch (event.key) {
      case 'ArrowLeft':
        targetTab = this.tabs[currentIndex - 1] || lastTab;
        break;
      case 'ArrowRight':
        targetTab = this.tabs[currentIndex + 1] || firstTab;
        break;
      case 'Home':
        targetTab = firstTab;
        break;
      case 'End':
        targetTab = lastTab;
        break;
      default:
        return;
    }
    event.preventDefault();
    this.activateTab(targetTab);
  }

  // Public methods for external control
  select(index) {
    if (index >= 0 && index < this.tabs.length) {
      this.activateTab(this.tabs[index]);
    }
  }
  destroy() {
    this.tabs.forEach(tab => {
      tab.removeEventListener('click', this.handleClick);
      tab.removeEventListener('keydown', this.handleKeydown);
    });
  }
}
export default () => {
  const tabContainer = getElements('.tabs');
  tabContainer.forEach(tab => {
    new Tabs(tab);
  });
};